import { render, staticRenderFns } from "./FemaleApproval.vue?vue&type=template&id=59777cda&scoped=true&"
import script from "./FemaleApproval.vue?vue&type=script&lang=js&"
export * from "./FemaleApproval.vue?vue&type=script&lang=js&"
import style0 from "./FemaleApproval.vue?vue&type=style&index=0&id=59777cda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59777cda",
  null
  
)

export default component.exports